export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    level: {
        label: "Level"
    },
    refDivisionId: {
        label: "Division"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    level: {
        label: "Niveau"
    },
    refDivisionId: {
        label: "Service"
    }
};